import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, DashboardModule,
} from '@domain-group/suit-theme'

import useCustomShortcode from '@hooks/useCustomShortcode'
import useCustomShortcodes from '@hooks/useCustomShortcodes'

import CustomShortcodeListItem from './CustomShortcodeListItem'

const CustomShortcodes = (props) => {
  const { ownerId, ownerType } = props

  const options = {
    entityKey: ownerType + ownerId,
    performHttpRequests: !!ownerType && !!ownerId,
    filters: {
      owner_id: ownerId,
      owner_type: ownerType,
    },
  }
  const customShortcodesPayload = useCustomShortcodes(options)
  const {
    filteredCustomShortcodes,
    hasFilteredCustomShortcodes,
    loading,
  } = customShortcodesPayload

  const {
    callbacks: { createOrEditCustomShortcode },
  } = useCustomShortcode({ owner_id: ownerId, owner_type: ownerType })

  return (
    <DashboardModule
      boxProps={{ id: 'realhub-nav-custom-shortcodes' }}
      loading={loading}
      title="Custom Shortcodes"
    >
      <Box flexDirection="column">
        <DashboardModule.ScrollableSection flexDirection="column">
          {!loading && !hasFilteredCustomShortcodes && (
            <DashboardModule.BlankState>
              <DashboardModule.BlankState.Title>
                No Custom Shortcodes present.
              </DashboardModule.BlankState.Title>

              <DashboardModule.BlankState.Paragraph>
                Please assign Custom Shortcodes.
              </DashboardModule.BlankState.Paragraph>
            </DashboardModule.BlankState>
          )}

          {!loading && filteredCustomShortcodes.map(customShortcode => (
            <CustomShortcodeListItem customShortcode={customShortcode} key={customShortcode.id} />
          ))}
        </DashboardModule.ScrollableSection>

        <DashboardModule.Footer boxProps={{ borderTop: loading ? 'none' : '1px solid' }}>
          <DashboardModule.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => createOrEditCustomShortcode()}
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Add Shortcode
            </Button>
          </DashboardModule.FooterRight>
        </DashboardModule.Footer>
      </Box>
    </DashboardModule>
  )
}

CustomShortcodes.propTypes = {
  ownerId: PropTypes.number.isRequired,
  ownerType: PropTypes.string.isRequired,
}

export default CustomShortcodes
